import type { Project, ProjectDetail } from "../types/Project";

export const projectDetails: ProjectDetail[] = [
  {
    id: 1,
    title: "Torch for Peace Conference",
    category: "Event Design",
    year: "2024",
    client: "Legal & Peacebuilding Organization",
    role: "Visual Designer & Event Communication Specialist",
    duration: "1 week",
    overview:
      // "A global event branding project promoting unity and nonviolence through impactful visual design and thoughtful communication materials.",
      // "Acara One Nation, One Peace adalah kegiatan interfaith service (layanan lintas agama) yang diselenggarakan oleh The International Stop the Violence Alliance, Inc. bersama The International Torch for Peace Foundation. Acara ini bertujuan menyatukan berbagai komunitas keagamaan melalui semangat nonkekerasan dan membangun komunitas yang saling percaya (building communities of trust). Kegiatan akan diadakan di Washington National Cathedral, Washington, DC pada 8 Februari 2025, pukul 11 pagi, diikuti oleh sesi makan siang (luncheon) dan penggalangan donasi.",
      "One Nation, One Peace is an interfaith service organized by The International Stop the Violence Alliance, Inc. and The International Torch for Peace Foundation. The event aims to unite diverse faith communities through the spirit of nonviolence and to build communities of trust. It will be held at the Washington National Cathedral in Washington, DC, on February 8th, 2025, at 11 AM, followed by a luncheon and donation opportunities.",
    challenge: [
      "Rising social tensions and violence require a unified, faith-based approach to promote peace and understanding.",
      "Lack of trust and communication between religious communities, civic organizations, and law enforcement often hinders collective peacebuilding efforts.",
      "Limited public awareness of nonviolence and interfaith cooperation, making it essential to create visible and inspiring initiatives to spread these values.",
      "Complex coordination needs among multiple organizations and supporters across regions, demanding clear planning and engagement strategies.",
    ],
    solution: [
      "Host an interfaith service as a symbolic and practical platform to bring together communities, leaders, and peace advocates in prayer and reflection.",
      "Promote the theme of nonviolence, emphasizing that peace begins with personal commitment and mutual respect among all people.",
      "Foster long-term trust and collaboration through follow-up dialogues, community programs, and continued partnership beyond the event.",
      "Encourage active participation and support by inviting attendees to RSVP, contribute donations, and engage in future peace-building activities under the Torch for Peace Foundation.",
    ],
    results: [
      "Increased conversion rate by 45%",
      "Reduced cart abandonment by 60%",
      "Improved user satisfaction score to 4.8/5",
    ],
    tools: ["Mockup"],
    colors: ["#6366F1", "#8B5CF6", "#EC4899", "#06B6D4"],
    liveUrl: "",
    githubUrl: "",
    figmaUrl: "",
    images: ["/projects/project-1-1.jpeg"],
    media: [
      {
        url: "/projects/project-1-1.jpeg", // Pinterest image
        type: "image",
      },
    ],
  },
  {
    id: 2,
    title: "Birthday Invitation Design",
    category: "Event Design",
    year: "2024",
    client: "Design Vendor Collaboration",
    role: "Visual Designer & Event Communication Specialist",
    duration: "1 week",
    overview:
      // "An urban-themed invitation design inspired by street art and graffiti culture. Bold typography and contrasting colors bring a modern, energetic vibe — perfect for youthful and creative celebrations.",
      "The poster announces a Bar Mitzvah celebration for Joshua, to be held on Thursday, September 7, 2023 (21 Eloul) at Duplex – Etsel, Hertzlia, starting at 7:00 PM. The event combines traditional significance with a modern, urban-graffiti visual style, reflecting both the importance of the Bar Mitzvah as a coming-of-age ceremony in Jewish tradition and Joshua’s youthful, contemporary personality.",
    challenge: [
      "Balancing tradition with modern expression — creating an event that honors the sacred meaning of a Bar Mitzvah while appealing to a younger generation.",
      "Design communication — ensuring that the graffiti-inspired poster still conveys elegance and respect appropriate for a religious milestone.",
      "Audience engagement — attracting both family and friends from different age groups and backgrounds to celebrate together in a cohesive atmosphere.",
    ],
    solution: [
      "Visual identity through graffiti design — using vibrant street-art elements to symbolize creativity, individuality, and youth while maintaining key ceremonial details.",
      "Clear and concise event information — presenting essential details (date, venue, time, RSVP) in a structured, readable format amidst the artistic background.",
      "Blending cultural and personal meaning — integrating modern aesthetics with traditional values to create a memorable and inclusive celebration that reflects Jos hua’s personality and heritage.",
    ],
    results: [
      "Decreased time-to-insight by 70%",
      "Increased user engagement by 85%",
      "Reduced support tickets by 40%",
    ],
    tools: ["Mockup"],
    colors: ["#3B82F6", "#06B6D4", "#10B981", "#F59E0B"],
    liveUrl: "",
    githubUrl: "",
    figmaUrl: "",
    images: ["/projects/project-1-2.jpeg"],
    media: [
      {
        url: "/projects/project-1-2.jpeg", // Pinterest image
        type: "image",
      },
    ],
  },
  {
    id: 3,
    title: "Torch for Peace Conference",
    category: "Event Design",
    year: "2024",
    client: "Legal & Peacebuilding Organization",
    role: "Visual Designer & Event Communication Specialist",
    duration: "1 week",
    // overview:
    //   "A global event branding project promoting unity and nonviolence through impactful visual design and thoughtful communication materials.",
    overview:
      "The 'Torch for Peace' event, titled 'One Nation, One Peace: An Interfaith Service Unifying Through Nonviolence,' is organized by the International Stop the Violence Alliance, Inc. and the International Torch for Peace Foundation. Scheduled for Saturday, February 8, 2025, this event promotes unity, justice, and peace among diverse communities through nonviolent collaboration and faith-based dialogue. The visual theme emphasizes strength, solidarity, and justice, symbolized by the raised fist and gavel.",
    challenge: [
      "Growing social and racial tensions that threaten unity and mutual trust within communities.",
      "The need to promote nonviolence and justice in a world increasingly polarized by conflict and inequality.",
      "Encouraging participation from different faiths and organizations in a single, inclusive event.",
      "Effectively communicating the event’s message of peace and unity through strong and meaningful imagery.",
    ],
    solution: [
      "Organize an interfaith service that brings together leaders, communities, and advocates from diverse backgrounds to reaffirm the power of peace through dialogue.",
      "Use symbolic visuals such as the raised fist and gavel to represent justice, empowerment, and solidarity under the principle of nonviolence.",
      "Foster cooperation and trust among community members by creating a shared platform for reflection, prayer, and action toward peace.",
      "Utilize clear communication channels for outreach, including RSVP email and hotline, ensuring accessibility and participation.",
    ],
    results: [
      "Increased conversion rate by 45%",
      "Reduced cart abandonment by 60%",
      "Improved user satisfaction score to 4.8/5",
    ],
    tools: ["Mockup"],
    colors: ["#6366F1", "#8B5CF6", "#EC4899", "#06B6D4"],
    liveUrl: "",
    githubUrl: "",
    figmaUrl: "",
    images: ["/projects/project-1-3.jpeg"],
    media: [
      {
        url: "/projects/project-1-3.jpeg", // Pinterest image
        type: "image",
      },
    ],
  },
  {
    id: 4,
    title: "Preparation for the Race of Life (Homecoming Program)",
    category: "Event Design",
    year: "2024",
    client: "Good News Community Seventh-day Adventist Church",
    role: "Graphic & Event Designer",
    duration: "1 week",
    // overview:
    // "A heartfelt homecoming invitation design celebrating togetherness and faith. Blending classic typography, warm tones, and illustrated scenery for an uplifting mood.Created to inspire reconnection and meaningful community engagement.",
    overview:
      "The Good News Community Seventh-day Adventist Church is organizing a Homecoming Program called 'In It To Win It' - Preparation for the Race of Life. This special event aims to reconnect with former members and the wider community through a day filled with drama, music, and encouraging interactions in an uplifting environment. The program is designed to bring people together for spiritual encouragement and fellowship, featuring lunch service and scheduled for December 28th, 2024, at Oldbury Campsite.",

    challenge: [
      "Reconnecting with inactive or former church members who may have drifted away from the community",
      "Creating an engaging and welcoming environment that appeals to both current and returning members",
      "Organizing a large-scale community event that requires significant planning and coordination",
      "Effectively communicating the event's value proposition to encourage attendance in a post-pandemic era where gathering habits have changed",
      "Providing meaningful spiritual content through drama and music that resonates with diverse age groups and backgrounds",
    ],

    solution: [
      "Developed a themed homecoming program 'In It To Win It' with relatable life race metaphor to attract broad audience",
      "Created a diverse program mix including drama, music, and interactive elements to cater to different preferences and engagement styles",
      "Organized complimentary lunch service to enhance community bonding and remove barriers to attendance",
      "Leveraged personal invitations and emphasized 'we miss you' messaging to create emotional connection and sense of belonging",
      "Selected accessible venue (Oldbury Campsite) with ample space for social interactions and community activities",
      "Scheduled event during holiday season (December 28th) to capitalize on family gatherings and availability",
    ],
    results: [
      "Increased conversion rate by 45%",
      "Reduced cart abandonment by 60%",
      "Improved user satisfaction score to 4.8/5",
    ],
    tools: ["Mockup"],
    colors: ["#6366F1", "#8B5CF6", "#EC4899", "#06B6D4"],
    liveUrl: "",
    githubUrl: "",
    figmaUrl: "",
    images: ["/projects/project-1-4.jpeg"],
    media: [
      {
        url: "/projects/project-1-4.jpeg", // Pinterest image
        type: "image",
      },
    ],
  },

  {
    id: 5,
    title: "Montego Bay Birthday Invitation Design",
    category: "Event Design",
    year: "2024",
    client: "Private Client - Montego Bay, Jamaica",
    role: "Lead Visual & Motion Designer",
    duration: "1 week",
    overview:
      "A tropical-themed birthday invitation inspired by the serene beaches of Montego Bay, designed to evoke feelings of relaxation, joy, and island luxury. The design combines warm sunset tones, gentle wave patterns, and elegant typography to create a festive yet sophisticated atmosphere. This invitation captures the essence of a beachside celebration while maintaining an upscale, luxurious feel perfect for a memorable birthday event.",

    challenge: [
      "Creating an authentic tropical/Montego Bay aesthetic that feels luxurious rather than generic beach theme",
      "Balancing warm sunset colors with elegant typography to maintain sophistication",
      "Effectively conveying both relaxation and celebration moods within the same design",
      "Incorporating wave and beach elements without making the design look cluttered or overwhelming",
      "Ensuring the tropical theme appeals to diverse guest demographics while maintaining upscale appeal",
      "Creating visual hierarchy that guides the viewer through invitation details while maintaining the scenic aesthetic",
    ],

    solution: [
      "Developed a sophisticated color palette using warm sunset tones (oranges, corals, golds) to evoke Montego Bay's famous sunsets",
      "Implemented gentle, flowing wave patterns as subtle background elements to suggest beachside setting without overpowering content",
      "Used elegant, clean typography with strategic hierarchy to ensure readability while maintaining luxurious feel",
      "Created balanced composition that divides space between scenic elements and essential party information",
      "Incorporated subtle texture overlays to mimic sand and water surfaces for authentic tropical ambiance",
      "Designed the layout to guide the eye naturally from the scenic elements to the key invitation details, creating a seamless visual journey",
    ],
    results: [
      "Increased conversion rate by 45%",
      "Reduced cart abandonment by 60%",
      "Improved user satisfaction score to 4.8/5",
    ],
    tools: ["Animation"],
    colors: ["#6366F1", "#8B5CF6", "#EC4899", "#06B6D4"],
    liveUrl: "https://pin.it/5yHqNZRby",
    githubUrl: "",
    figmaUrl: "",
    images: ["/projects/project-1-5.jpeg"],
    media: [
      {
        url: "/projects/project-1-5.jpeg",
        type: "image",
      },
      {
        url: "https://assets.pinterest.com/ext/embed.html?id=1013661828639613273",
        type: "pinterest",
      },
    ],
  },

  {
    id: 6,
    title: "Ojay’s 65th Birthday Invitation Design",
    category: "Event Design",
    year: "2024",
    client: "Private Client – Ojay’s 65th Celebration",
    role: "Visual Designer & Event Communication Specialist",
    duration: "1 Week",
    overview:
      "A sophisticated travel-themed birthday invitation designed to celebrate Ojay's 65th birthday, symbolizing his life journey as an adventure around the world. The design features elegant maps, vintage motifs, and warm color tones that evoke nostalgia, wanderlust, and personal milestones. This invitation sets the tone for a memorable celebration honoring 65 years of life experiences, travels, and cherished memories.",

    challenge: [
      "Creating a design that meaningfully represents 65 years of life journey in a travel-themed concept",
      "Balancing elegant aesthetics with warm, inviting tones to appeal to guests of all ages",
      "Incorporating vintage elements while maintaining a modern, sophisticated appeal",
      "Effectively communicating the travel/adventure theme without overwhelming the birthday celebration focus",
      "Designing a layout that accommodates essential party details while maintaining the artistic travel concept",
      "Ensuring the design evokes emotional connection to Ojay's personal journey and milestones",
    ],

    solution: [
      "Developed a cohesive travel-inspired visual identity using elegant maps as central design elements",
      "Utilized warm color palette with vintage motifs to create nostalgic yet sophisticated atmosphere",
      "Implemented clean typography hierarchy to ensure party details remain clear and readable",
      "Created metaphorical connection between '65-year journey' and 'world travel' theme for emotional resonance",
      "Designed balanced layout that showcases artistic elements while prioritizing essential information",
      "Incorporated subtle vintage textures and patterns to enhance the travel adventure narrative without distracting from main content",
    ],
    results: [
      "Increased conversion rate by 45%",
      "Reduced cart abandonment by 60%",
      "Improved user satisfaction score to 4.8/5",
    ],
    tools: ["Mockup"],
    colors: ["#6366F1", "#8B5CF6", "#EC4899", "#06B6D4"],
    liveUrl: "",
    githubUrl: "",
    figmaUrl: "",
    images: ["/projects/project-1-6.jpeg"],
    media: [
      {
        url: "/projects/project-1-6.jpeg", // Pinterest image
        type: "image",
      },
    ],
  },
];

export const projects: Project[] = projectDetails.map((project) => ({
  id: project.id,
  title: project.title,
  category: project.category,
  images: project.images,
  desc: project.overview,
  tags: project.tools.slice(0, 3),
  link: `/projects/${project.id}`,
}));
